import {useMutation} from 'react-query';
import {removeExtraSubscriptions} from '../Calls/Admin';

export const useRemoveExtraSubscriptions = () => {
  return useMutation(removeExtraSubscriptions, {});
};
